import { z } from "zod";

import {
  type AgentCapabilityKey,
  GOVERNED_CAPABILITY_CONTRACTS,
  type GovernedCapabilityContract,
  type GovernedInsightReportCapabilityKey,
} from "./contracts";

export const governedToolGroupForCapability = (name: string) => {
  const contract: GovernedCapabilityContract | undefined = GOVERNED_CAPABILITY_CONTRACTS.find(
    candidate => candidate.capabilityKey === name,
  );
  return contract?.toolGroup;
};

export const AgentCapabilityKeySchema = z.custom<AgentCapabilityKey>(
  value => typeof value === "string" && GOVERNED_CAPABILITY_CONTRACTS.some(contract => contract.capabilityKey === value),
  "Unknown governed capability key.",
);

export const AGENT_CAPABILITY_KEYS: AgentCapabilityKey[] = GOVERNED_CAPABILITY_CONTRACTS.map(contract => contract.capabilityKey);

export const GovernedInsightReportCapabilityKeySchema = z.custom<GovernedInsightReportCapabilityKey>(
  value =>
    typeof value === "string" &&
    GOVERNED_CAPABILITY_CONTRACTS.some(contract => contract.capabilityClass === "report" && contract.capabilityKey === value),
  "Unknown governed report capability key.",
);

export const GOVERNED_INSIGHT_REPORT_CAPABILITY_KEYS: GovernedInsightReportCapabilityKey[] = GOVERNED_CAPABILITY_CONTRACTS.filter(
  contract => contract.capabilityClass === "report",
).map(contract => contract.capabilityKey);

export type { AgentCapabilityKey, GovernedInsightReportCapabilityKey } from "./contracts";
